import { format, isSameDay } from 'date-fns';
import styled from 'styled-components';

import { Text } from '../../../../cdl/Text/Text';
import { formatDateTime } from '../../../../common/helpers/formatDateTime.helper';
import { translate } from '../../../../common/helpers/translate.helper';
import { useEnums } from '../../../../common/hooks/useEnums';
import { Box } from '../../../../common/ui/Box';
import { theme } from '../../../../common/ui/theme';

interface EmptyAverageConsumptionCategoryProps {
    category: string;
    dateRange: Date[];
}

const NoDataArea = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;

    // Styles for a custom dashed border with 6px dash and 6px gap
    background-image: repeating-linear-gradient(
            0deg,
            ${theme.colors.border.muted},
            ${theme.colors.border.muted} 6px,
            transparent 6px,
            transparent 12px,
            ${theme.colors.border.muted} 12px
        ),
        repeating-linear-gradient(
            90deg,
            ${theme.colors.border.muted},
            ${theme.colors.border.muted} 6px,
            transparent 6px,
            transparent 12px,
            ${theme.colors.border.muted} 12px
        ),
        repeating-linear-gradient(
            180deg,
            ${theme.colors.border.muted},
            ${theme.colors.border.muted} 6px,
            transparent 6px,
            transparent 12px,
            ${theme.colors.border.muted} 12px
        ),
        repeating-linear-gradient(
            270deg,
            ${theme.colors.border.muted},
            ${theme.colors.border.muted} 6px,
            transparent 6px,
            transparent 12px,
            ${theme.colors.border.muted} 12px
        );
    background-size:
        1px 100%,
        100% 1px,
        1px 100%,
        100% 1px;
    background-position:
        0 0,
        0 0,
        100% 0,
        0 100%;
    background-repeat: no-repeat;
`;

export const EmptyAverageConsumptionCategory = (props: EmptyAverageConsumptionCategoryProps) => {
    const { getHumanReadableValue } = useEnums();

    const isToday = isSameDay(props.dateRange[1], new Date());
    const endDate = isToday ? translate('vessel.averageConsumption.today') : format(props.dateRange[1], 'MMM d');

    return (
        <Box display="grid" gap={8} gridTemplateRows="min-content 1fr min-content">
            <Text fontWeight={600} variant="body">
                {getHumanReadableValue('vesselTankCategory', props.category)}
            </Text>

            <NoDataArea>
                <Text color="foreground.subtle" variant="body" as="p">
                    {translate('vessel.averageConsumption.noConsumptionPlaceholder')}
                </Text>
            </NoDataArea>

            <Box display="flex" justifyContent="space-between">
                <Text variant="extraSmall" color="foreground.subtle">
                    {formatDateTime({ date: props.dateRange[0].toISOString(), format: 'MMM d' })}
                </Text>
                <Text variant="extraSmall" color="foreground.subtle">
                    {endDate}
                </Text>
            </Box>
        </Box>
    );
};
